import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { toRichText } from './rich-text.util';

/**
 * Renders stored section text (rich HTML or legacy plain text) for display.
 * Use with [innerHTML] on a block element (not a <p>, since the output
 * contains paragraphs) styled with the `rich-text-content` class.
 *
 * The HTML is sanitized by `toRichText` (DOMPurify, editor-subset allowlist)
 * before being trusted — Angular's own sanitizer would strip the inline
 * colour / highlight / font styles the editor produces.
 */
@Pipe({
  name: 'richText',
  standalone: true,
})
export class RichTextPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(toRichText(value));
  }
}
